module.exports = __webpack_public_path__ + "static/media/token-icon.48ebbe74.svg";